import React, { useEffect, useState } from 'react';
import { HERO_IMAGE, HERO_IMAGE_ALT, HERO_IMAGE_HEIGHT, HERO_IMAGE_WIDTH } from '../data/media';
import { removeWhiteBackground } from '../utils/removeWhiteBackground';
type HeroImageProps = {
  className?: string;
};
export function HeroImage({
  className = ''
}: HeroImageProps) {
  const [src, setSrc] = useState(HERO_IMAGE);
  useEffect(() => {
    let active = true;
    removeWhiteBackground(HERO_IMAGE).then(result => {
      if (active) setSrc(result);
    });
    return () => {
      active = false;
    };
  }, []);
  return <img src={src} alt={HERO_IMAGE_ALT} width={HERO_IMAGE_WIDTH} height={HERO_IMAGE_HEIGHT} decoding="async" fetchPriority="high" className={className} data-id="element-143" data-mp="9p4wv2kuces2" />;
}